let PageData = {};
let GlobalData = {};
let ActivePage = "";

if (process.env.NODE_ENV === "production") {
  ActivePage = window.pageDataModel ? window.pageDataModel.pageName : "";
  if (ActivePage) PageData = window.pageDataModel;

  GlobalData = window.globalDataModel;
} else {
  // All pages:
  // BillPayment
  // MyAccount
  // NetNeutrality
  // RedPass
  // OTP
  // OfferWeb
  // OrderTrackingTool
  // PlanSelector
  // Koftis
  // TopUp
  // PaymentResult
  // SAMOffer
  // GDPR
  // eBillManagement
  // MarketPlace
  // MarketPlaceRegistration
  // DataBundles
  // OTTRegistration
  // NewLineUp
  // PersonalizedOffer
  // Settings
  // Prepaid * UNIFICATION OF TOURIST - INTERNATIONAL
  // PrepaidYou
  // PrepaidTourist
  // PrepaidMsisdn
  // TobiLanding
  // Eve
  // DocumentsUpload
  // SmartBill
  // FixedPlansConfigurator
  // FixedContract
  // KoftisEnable
  // AnonymousAskOnce
  // EsimActivation
  // HelpMeChoose
  // FixedSameTariff
  // DigitalPromos
  // Unemployment
  // AnonymousMajorIncidents
  // EsimConsent
  // MobileMultipleOffers
  // Combo
  // VBGDigitalJourneys
  // ChangePassword
  // Dsl2vdsl
  // MyOffers
  // TvFilter
  // ChangeBillingAddress
  // DeviceInstallmentsPayment
  // RoojoomFlows
  // Basket
  // CheckoutOnboarding

  // change this variable during development to load a different page
  ActivePage = "MyAccount";
  GlobalData = require("./data-models/_GlobalData").data;
  setMockPageData(ActivePage);
}

function setMockPageData(page) {
  PageData = require("./data-models/" + page).data;
}

export { PageData, GlobalData, ActivePage, setMockPageData };
